import React, { useContext } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DataContext } from "../../../../../../../providers/ElectricityCheckoutDataProvider";
import Margin from "../../../../../../shared/Margin";
import Headline from "../../../../../../shared/NewHeadline";

const Place = styled.div`
    display: flex;
    flex-grow: 1;
`;

const fieldStyles = css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

const DeliveryAddress = () => {
    const dataContext = useContext(DataContext);
    const { zipcode, street, houseNum, place } = dataContext.data;

    return (
        <React.Fragment>
            <Headline>Lieferadresse</Headline>
            <Margin left="10" right="10">
                {String(street) + " " + String(houseNum)}
            </Margin>
            <div className="field" css={fieldStyles}>
                <Margin left="10" right="10">
                    {zipcode}
                </Margin>
                <Place>{place}</Place>
            </div>
        </React.Fragment>
    );
};

export default DeliveryAddress;
